import { useState, useCallback } from 'react';
import { message } from 'antd';
import { d324Api, QueryParams, ReportRow, CurrencySummary } from '../../../services/d324Api';

export function useD324Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [currencySummary, setCurrencySummary] = useState<CurrencySummary[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await d324Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setCurrencySummary(resp.currency_summary || []);
        setNoData(false);
      } else {
        setData([]);
        setCurrencySummary([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setCurrencySummary([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, currencySummary, queried, noData, runQuery, reset };
}
